<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
			<v-tooltip bottom v-if="design === 1">
				<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
					<v-btn
						depressed
						color="#959595"
						outlined
						small
						dark
						v-bind="{ ...menuAttrs, ...tooltipAttrs }"
						v-on="{ ...menuOn, ...tooltipOn }"
					>
						<v-icon size="22">mdi-file-document-plus-outline</v-icon>
					</v-btn>
				</template>
				<span>Historial de Requerimientos Adicionales</span>
			</v-tooltip>
			<v-tooltip bottom v-else-if="design === 2">
				<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
					<v-btn
						depressed
						color="#959595"
						class="mr-1"
						small
						dark
						v-bind="{ ...menuAttrs, ...tooltipAttrs }"
						v-on="{ ...menuOn, ...tooltipOn }"
					>
						<v-icon size="24">mdi-file-document-plus-outline</v-icon>
					</v-btn>
				</template>
				<span>Historial de Requerimientos Adicionales</span>
			</v-tooltip>
		</template>
		<v-list dense class="py-0" style="min-width: 400px">
			<v-list-item dense class="mb-1 px-1" style="min-height: 25px; background: #959595;">
				<div class="d-flex justify-space-between align-center w-100 px-1 py-1 mx-1">
					<p class="caption mb-0 font-weight-bold white--text">Historial de Requerimientos Adicionales</p>
					<div class="ml-6 d-flex justify-end align-center" v-if="!isClient">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
							<div v-bind="attrs" v-on="on">
								<v-btn
									small
									depressed
									dark
									:disabled="hasPendingRequest"
									@click="startAdditionalRequirement"
									style="background-color: #FF120B; text-transform: none; letter-spacing: 0; height: 24px; font-size: 12px;"
							>
									<v-icon small left style="font-size: 14px;">mdi-plus</v-icon>
									Nuevo
							</v-btn>
							</div>
							</template>
							<span v-if="hasPendingRequest">Hay una solicitud pendiente de respuesta, espera la respuesta del cliente (o cancelala) antes de iniciar otra.</span>
							<span v-else>Enviar nueva solicitud al cliente</span>
						</v-tooltip>
					</div>
				</div>
			</v-list-item>
			<v-list-item-group color="#524D4D" v-if="additionalRequestList.length">
				<v-list-item
					v-for="(item, index) in additionalRequestList"
					:key="'ass-'+index"
					dense
					@click="viewDetail(item)"
					style="min-width: 200px"
				>
					<v-list-item-title dense>
						<div class="d-flex justify-space-between align-center item-background-hover">
							<div class="d-flex align-center justify-space-between caption py-1" style="width: 100%; gap: 8px;">
								<div style="width: 90px">Ver Detalle</div>
								<div class="text-end">
									<v-chip
										:color="getStatusColor(item.status)"
										text-color="white"
										x-small
									>
										{{ getStatusLabel(item.status) }}
									</v-chip>
									<p class="mb-0" style="font-size: 10px;">Creada: <b>{{ item.created_at | toDateTime }}</b></p>
								</div>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item>
			</v-list-item-group>
			<v-list-item v-else>
				<div class="d-flex justify-center align-center caption">
					<p class="mb-0">No hay Solicitudes Ingresadas</p>
				</div>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	name: 'AdditionalRequirementsMenu',
	props: {
		contract: {
			type: Object,
			required: false
		},
		project: {
			type: Object,
			required: true
		},
		design: {
			type: Number,
			default: 1
		}
	},
	computed: {
		userInfo(){
			return this.$store.state.user.userInfo
		},
		isClient(){
			return this.userInfo?.id == this.project?.client?.id
		},
		additionalRequestList(){
			return this.project?.additional_requests || []
		},
		hasPendingRequest(){
			return this.additionalRequestList.some(item => item.status === 1)
		}
	},
	mounted() {
		const project_additional_request_id = this.$route.query.par
		if(project_additional_request_id){
			this.$store.commit('projects/setAdditionalRequirementDetailModal', {
				additional_request_id: project_additional_request_id,
			})
		}
	},
	methods: {
		startAdditionalRequirement(){
			const project_client = this.project?.client?.profile?.name + ' ' + this.project?.client?.profile?.lastname  + ' ' + this.project?.client?.profile?.second_lastname || this.project?.client?.name || ''
			const data = {
				project_id: this.project?.id,
				contract_id: this.contract?.id,
				project_name: this.project?.name,
				project_client
			}
			this.$store.commit('projects/setProjectAdditionalRequirementInfoModal', data)
		},
		viewDetail(additional){
			this.$store.commit('projects/setAdditionalRequirementDetailModal', {
				additional_request_id: additional.id,
			})
		},
		getStatusColor(status){
			const statusColors = {
				1: '#FFA500', // Pendiente
				2: '#9E9E9E', // Cancelada
				3: '#4CAF50', // Aprobada
				4: '#F44336'  // Rechazada
			}
			return statusColors[status] || '#9E9E9E'
		},
		getStatusLabel(status){
			const statusLabels = {
				1: 'Pendiente',
				2: 'Cancelada',
				3: 'Aprobada',
				4: 'Rechazada'
			}
			return statusLabels[status] || status
		}
	},
}
</script>

<style scoped>
.v-btn--disabled {
    background-color: rgba(255, 255, 255, 0.3) !important;
}
</style>